<template>
  <!-- タブボタン部分 -->
  <ul class="nav nav-tabs">
    <li class="nav-item" v-if="loginUserInfo.auth_ref_order">
      <a
        href="#"
        class="nav-link"
        :class="{ active: active === 'order' }"
        @click.prevent="
          submitAsteria(
            'ReferOrder',
            'loadHTML_forReferOrder',
            {},
            '',
            '/reference/order.html'
          )
        "
        >ご発注確認</a
      >
    </li>
    <li class="nav-item" v-if="loginUserInfo.auth_ref_orderrest">
      <a
        href="#"
        class="nav-link"
        :class="{ active: active === 'order_rest' }"
        @click.prevent="
          submitAsteria(
            'ReferOrderRest',
            'loadHTML_forReferOrderRest',
            {},
            '',
            '/reference/order_rest.html'
          )
        "
        >ご発注残確認</a
      >
    </li>
    <li class="nav-item" v-if="loginUserInfo.auth_ref_purchaseresults">
      <a
        href="#"
        class="nav-link"
        :class="{ active: active === 'purchase_results' }"
        @click.prevent="
          submitAsteria(
            'ReferPurchaseResults',
            'loadHTML_forReferPurchaseResults',
            {},
            '',
            '/reference/purchase_results.html'
          )
        "
        >仕入実績</a
      >
    </li>
    <li class="nav-item" v-if="loginUserInfo.auth_ref_inventory">
      <a
        href="#"
        class="nav-link"
        :class="{ active: active === 'inventory' }"
        @click.prevent="
          submitAsteria(
            'ReferInventory',
            'loadHTML_forReferInventory',
            {},
            '',
            '/reference/inventory.html'
          )
        "
        >在庫照会</a
      >
    </li>
    <li class="nav-item" v-if="loginUserInfo.auth_ref_deliveryslip">
      <a
        href="#"
        class="nav-link"
        :class="{ active: active === 'delivery_slip' }"
        @click.prevent="
          submitAsteria(
            'ReferDeliverySlip',
            'loadHTML_forReferDeliverySlip',
            {},
            '',
            '/reference/delivery_slip.html'
          )
        "
        >納品書</a
      >
    </li>
    <li class="nav-item" v-if="loginUserInfo.auth_ref_itemprice">
      <a
        href="#"
        class="nav-link"
        :class="{ active: active === 'item_price' }"
        @click.prevent="
          submitAsteria(
            'ReferItemPrice',
            'loadHTML_forReferItemPrice',
            {},
            '',
            '/reference/item_price.html'
          )
        "
        >価格照会</a
      >
    </li>
    <li class="nav-item" v-if="loginUserInfo.auth_ref_invoice">
      <a
        href="#"
        class="nav-link"
        :class="{ active: active === 'bill' }"
        @click.prevent="
          submitAsteria(
            'ReferBill',
            'loadHTML_forReferBill',
            {},
            '',
            '/reference/bill.html'
          )
        "
        >請求書</a
      >
    </li>
    <li class="nav-item" v-if="loginUserInfo.auth_ref_printableitem">
      <a
        href="#"
        class="nav-link"
        :class="{ active: active === 'printable_item' }"
        @click.prevent="
          submitAsteria(
            'ReferPrintableItem',
            'loadHTML_forReferPrintableItem',
            {},
            '',
            '/reference/printable_item.html'
          )
        "
        >印刷品確認</a
      >
    </li>
    <li class="nav-item" v-if="loginUserInfo.auth_ref_accounts_payable">
      <a
        href="#"
        class="nav-link"
        :class="{ active: active === 'payable' }"
        @click.prevent="
          submitAsteria(
            'ReferPayable',
            'loadHTML_forReferPayable',
            {},
            '',
            '/reference/payable.html'
          )
        "
        >貴社請求書</a
      >
    </li>
    <li class="nav-item" v-if="loginUserInfo.auth_ref_csvhistory">
      <a
        href="#"
        class="nav-link"
        :class="{ active: active === 'csv_history' }"
        @click.prevent="
          submitAsteria(
            'ReferCSVHistory',
            'loadHTML_forCsvHistory',
            {},
            '',
            '/reference/csv_history.html'
          )
        "
        >取込出力履歴</a
      >
    </li>
    <li class="nav-item" v-if="loginUserInfo.auth_ref_productmaster">
      <a
        href="#"
        class="nav-link"
        :class="{ active: active === 'product_master' }"
        @click.prevent="
          submitAsteria(
            'ReferProductMaster',
            'loadHTML_forReferProductMaster',
            {},
            '',
            '/reference/product_master.html'
          )
        "
        >商品マスタ照会</a
      >
    </li>
  </ul>
</template>

<script>
import { store as loginUserStore } from "../../store/LoginUser";

export default {
  props: {
    active: { props: String, required: true }
  },

  computed: {
    loginUserInfo() {
      return loginUserStore.info;
    }
  }
};
</script>
